var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"machinePage"},[_c('v-timeline',[_c('v-timeline-item',[_vm._v("timeline item")]),_c('v-timeline-item',{staticClass:"text-right"},[_vm._v(" timeline item ")]),_c('v-timeline-item',[_vm._v("timeline item")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }